import React from 'react';
import './PainelParalaxe4.css';

const PainelParalaxe4 = () => {
  return (
    <div className="paralaxe-container4">
      <div className="paralaxe-conteudo4">
        <div className="paralaxe-texto-container4">
          <h2 className="paralaxe-titulo4">Sofisticação e exclusividade</h2>
          <p className="paralaxe-texto4">
            Projetos exclusivos que expressam, em cada detalhe, seu estilo de vida e sua visão, de maneira marcante.
             Sofisticação e funcionalidade caminham juntas em cada criação, sempre única, sempre do seu jeito.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PainelParalaxe4;